import { Exclude, Expose } from 'class-transformer';
import { ApiProperty } from '@nestjs/swagger';
import { IsBoolean, IsIP, IsISO8601, IsString } from 'class-validator';
import { LoginAttemptInterface } from '../interfaces/login-attempt.interface';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';

@Exclude()
export class LoginAttemptDto
  extends CommonEntityDto
  implements LoginAttemptInterface
{
  @ApiProperty({
    type: 'string',
    title: 'Username',
    description: 'The username used in the login attempt',
  })
  @IsString()
  @Expose()
  username!: string;

  @ApiProperty({
    type: 'string',
    title: 'IP Address',
    description: 'The IP address from which the login attempt was made',
  })
  @IsIP()
  @Expose()
  ipAddress!: string;

  @ApiProperty({
    type: 'string',
    format: 'date-time',
    title: 'Attempt Time',
    description: 'The timestamp when the login attempt occurred',
  })
  @IsISO8601({ strict: true })
  @Expose()
  attemptTime!: Date;

  @ApiProperty({
    type: 'boolean',
    title: 'Success',
    description: 'Whether the login attempt was successful',
  })
  @IsBoolean()
  @Expose()
  success!: boolean;
}
